import { render } from "./ChangeShapeIcon.vue?vue&type=template&id=156dca18&scoped=true"
import script from "./ChangeShapeIcon.vue?vue&type=script&lang=js"
export * from "./ChangeShapeIcon.vue?vue&type=script&lang=js"

import "./ChangeShapeIcon.vue?vue&type=style&index=0&id=156dca18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156dca18"]])

export default __exports__